// extracted by mini-css-extract-plugin
export default {"heroSection":"a_heroSection__Mf-FO","searchPanel":"a_searchPanel__HdXRI","card":"a_card__Kglq3","details":"a_details__Rflht","info":"a_info__r0hAT"};